import { render, staticRenderFns } from "./storeAcceptRecord.vue?vue&type=template&id=b8f9ffb8"
import script from "./storeAcceptRecord.vue?vue&type=script&lang=js"
export * from "./storeAcceptRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports